import { useState, useEffect } from 'react';
import { Modal, Button } from '@components/ui';

/**
 * StokModal - Demir stok güncelleme
 */
export default function StokModal({ isOpen, onClose, onSubmit, data, isLoading = false }) {
    const [stok, setStok] = useState(0);
    const [kullanilan, setKullanilan] = useState(0);
    const [not, setNot] = useState('');

    useEffect(() => {
        if (data) {
            setStok(data.stokMiktar || 0);
            setKullanilan(data.kullanilanMiktar || 0);
        }
    }, [data]);

    const handleStokChange = (value) => {
        const newStok = Math.max(0, parseFloat(value) || 0);
        setStok(newStok);
        setKullanilan(Math.max(0, (data?.miktar || 0) - newStok));
    };

    const handleKullanilanChange = (value) => {
        const newKullanilan = Math.max(0, parseFloat(value) || 0);
        setKullanilan(newKullanilan);
        setStok(Math.max(0, (data?.miktar || 0) - newKullanilan));
    };

    const handleSubmit = () => {
        onSubmit({ stokMiktar: stok, kullanilanMiktar: kullanilan, not });
    };

    if (!data) return null;

    return (
        <Modal isOpen={isOpen} onClose={onClose} title="Stok Güncelle" size="sm"
            footer={<><Button variant="ghost" onClick={onClose} disabled={isLoading}>İptal</Button><Button variant="success" onClick={handleSubmit} isLoading={isLoading}>Güncelle</Button></>}>
            <div className="space-y-4">
                {/* Bilgi */}
                <div className="p-3 bg-bg-tertiary rounded-lg">
                    <div className="flex items-center gap-2 mb-1">
                        <span className="px-2 py-0.5 bg-info/10 text-info rounded text-xs font-medium">{data.cap}</span>
                        <span className="text-sm text-text-muted">{data.kalite}</span>
                    </div>
                    <p className="font-medium text-text-primary">{data.tedarikci}</p>
                    <p className="text-sm text-text-secondary">Toplam: {data.miktar} ton</p>
                </div>

                {/* Stok */}
                <div>
                    <label className="block text-sm font-medium text-text-primary mb-1.5">Mevcut Stok (ton)</label>
                    <input type="number" step="0.1" value={stok} onChange={(e) => handleStokChange(e.target.value)}
                        className="w-full px-3 py-2.5 bg-bg-primary border border-border-light rounded-lg text-sm text-text-primary focus:outline-none focus:ring-2 focus:ring-success/50" />
                </div>

                {/* Kullanılan */}
                <div>
                    <label className="block text-sm font-medium text-text-primary mb-1.5">Kullanılan (ton)</label>
                    <input type="number" step="0.1" value={kullanilan} onChange={(e) => handleKullanilanChange(e.target.value)}
                        className="w-full px-3 py-2.5 bg-bg-primary border border-border-light rounded-lg text-sm text-text-primary focus:outline-none focus:ring-2 focus:ring-primary/50" />
                </div>

                {/* Progress */}
                <div className="space-y-1">
                    <div className="flex justify-between text-xs text-text-muted">
                        <span>Kullanım</span>
                        <span>%{data.miktar > 0 ? Math.round((kullanilan / data.miktar) * 100) : 0}</span>
                    </div>
                    <div className="h-2 bg-bg-tertiary rounded-full overflow-hidden">
                        <div className="h-full bg-success rounded-full transition-all" style={{ width: `${data.miktar > 0 ? (kullanilan / data.miktar) * 100 : 0}%` }} />
                    </div>
                </div>

                {/* Not */}
                <div>
                    <label className="block text-sm font-medium text-text-primary mb-1.5">Not</label>
                    <input type="text" value={not} onChange={(e) => setNot(e.target.value)} placeholder="Güncelleme notu..."
                        className="w-full px-3 py-2.5 bg-bg-primary border border-border-light rounded-lg text-sm text-text-primary focus:outline-none focus:ring-2 focus:ring-primary/50" />
                </div>
            </div>
        </Modal>
    );
}
